var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h2", { staticClass: "nodal-title" }, [
      _vm._v("\n\t\tCreate Discussion Post\n\t"),
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "Discussion Posts are frequently used to measure student participation in class."
      ),
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "Discussion Posts include the body and reference section on a single page. This makes it easy to copy and paste its content into a web forum."
      ),
    ]),
    _vm._v(" "),
    _c(
      "form",
      [
        _c("form-select", {
          attrs: {
            label: "Paper Format",
            "select-object": _vm.paperFormatSelectList,
          },
          model: {
            value: _vm.paperType,
            callback: function ($$v) {
              _vm.paperType = $$v
            },
            expression: "paperType",
          },
        }),
        _vm._v(" "),
        _c("form-input", {
          attrs: {
            label: "Title",
            placeholder: "(required)",
            "form-id": _vm.zFormId,
            "validate-enum": _vm.$enums.Validation.REQUIRED,
          },
          model: {
            value: _vm.title,
            callback: function ($$v) {
              _vm.title = $$v
            },
            expression: "title",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-6" }, [
            _c("div", { staticClass: "d-grid mt-2" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-danger",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.emitter.emit("closeRouteModal")
                    },
                  },
                },
                [_vm._v("\n\t\t\t\t\t\tCancel\n\t\t\t\t\t")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-6" }, [
            _c("div", { staticClass: "d-grid mt-2" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  attrs: { type: "submit" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.createDiscussionPost.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("\n\t\t\t\t\t\tCreate Discussion Post\n\t\t\t\t\t")]
              ),
            ]),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }